import { z } from 'zod'

import type { Language } from '@nxt-insurance/constants'

import { dentalInsuranceSchema } from '@flows/configs/de/dental/types'
import type { generateGetFlowValueFunctions } from '@flows/insurance/utils'

export interface DentalStepParams {
  getCurrentLanguage: () => Language
  helperFunctions: ReturnType<typeof generateGetFlowValueFunctions>
  platform: 'web' | 'native'
  environment: string
}

export const healthInsuranceTypeSchema = z.object({
  products: z.object({
    mga_dental_de: z.object({
      configuration_parameters: dentalInsuranceSchema.pick({
        health_insurance_type: true,
      }),
    }),
  }),
})
export const existingDentalInsuranceSchema = z.object({
  products: z.object({
    mga_dental_de: z.object({
      configuration_parameters: dentalInsuranceSchema.pick({
        has_existing_dental_insurance: true,
      }),
    }),
  }),
})
export const earnsAboveThresholdSchema = z.object({
  products: z.object({
    mga_dental_de: z.object({
      configuration_parameters: dentalInsuranceSchema.pick({
        earns_above_threshold: true,
      }),
    }),
  }),
})
export const ineligibleStatusSchema = z.object({})
export const redirectToAllianzSchema = z.object({})
export const successSchema = z.object({})
